import { IconTag } from '@tabler/icons-react'

export const PERMISSION_SETS_TAGS = {
  id: 'Tags',
  description: 'Grant access to add and remove edit tags to records.',
  icon: IconTag,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'Add and remove all non-exclusive tags to records',
        },
        {
          type: 'checkbox',
          label: 'Create, edit, and delete exclusive tags',
          info: 'Full access is required for this action.',
        },
        {
          type: 'checkbox',
          label: 'Add and remove all exclusive tags to records',
        },
        {
          type: 'checkbox',
          label: 'Add and remove these exclusive tags to records',
        },
        {
          type: 'multiselect',
          label: 'Exclusive tags',
          withAsterisk: true,
          data: [
            { label: 'Tag 1', value: 'TAG_1' },
            { label: 'Tag 2', value: 'TAG_2' },
          ],
        },
      ],
    },
  ],
}
